// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1oP2s","select":"Header_select__lJQJR","clinic":"Header_clinic__2gPEn"};